import { faArrowRight } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'

const Section2 = () => {

  const cards = [
    {
      icon: 'https://skilleareumimages.s3.ap-south-1.amazonaws.com/New/Landing/section22.svg',
      title: 'Play ',
      desc: 'Experience daily excitement through interactive challenges from testing your luck with Spin to Win, to enjoying engaging games like Missing Letters, Jumble Letters, Perfect Match, and Memory Game.  ',
    },
    {
      icon: 'https://skilleareumimages.s3.ap-south-1.amazonaws.com/New/Landing/section23.svg',
      title: 'Learn ',
      desc: ' Unlock daily insights through AI Facts, get hands-on with real tools in AI Space, and spend 30 days mastering 30 must-know AI Jargons with simple, fun assessments that keep you sharp.  ',
    },
    {
      icon: 'https://skilleareumimages.s3.ap-south-1.amazonaws.com/New/Landing/section24.svg',
      title: 'Earn ',
      desc: 'Every task you complete, every challenge you master, every day you participate earns you Skill Points (Future SKLRM tokens) and Instant Referral Bonuses giving every learner the chance to turn effort into long-term rewards. ',
    },
    {
      icon: 'https://skilleareumimages.s3.ap-south-1.amazonaws.com/New/Landing/section25.svg',
      title: 'Grow ',
      desc: ' With consistency comes the opportunity to Grow. Following your personalized learning path every day will lead you from foundational knowledge to advanced understanding, helping you master AI skills in this competitive, ever-changing world.',
    },
    {
      icon: 'https://skilleareumimages.s3.ap-south-1.amazonaws.com/New/Landing/section26.svg',
      title: 'Repeat ',
      desc: "Growth doesn't stop once you’ve made progress. To stay on top and to keep the momentum going, stay updated with our fresh challenges, new updates along with our evolving community of fellow learners. ",
    },
    {
      icon: 'https://skilleareumimages.s3.ap-south-1.amazonaws.com/New/Landing/section21.svg',
      title: ' What’s Next? ',
      desc: 'This is just the beginning. Get Ready to experience NFT-based learning, Advanced learning modules, and even deeper rewards designed to help you stay ahead. ',
    },
  ]
  return (
    <div className='pt-10 '>
      <div className=' relative overflow-hidden flex justify-center items-center'>
       <div className='w-full h-full absolute top-0 '>
            <div className='w-[80%] mx-auto h-10 absolute top-0 left-0 right-0 opacity-60 bg-[#727272] rounded-full '></div>
            <div className=' w-32 h-16 absolute top-20 -right-10 bg-[#00BA34] opacity-55 rounded-full '></div>
            <div className=' w-8 h-24 absolute top-16 -left-5 bg-[#00BA34] opacity-55 rounded-full '></div>
            {/* <div className='w-44 mx-auto h-10 absolute bottom-0 left-0 right-0 opacity-60 bg-[#3055E3] rounded-full '></div> */}
        </div>
      <div className='w-[100%] mx-auto py-20 px-3 font-gilroy bg-[#8989890D] border border-white/5 backdrop-blur-3xl rounded-2xl '>
        <div>
          <p className=' font-bold text-3xl text-center leading-10 '>Why Choose <span style={{
            backgroundClip: "text",
            color: "transparent",
            backgroundImage: "linear-gradient(to right, #0285FF, #1EEF32)",
            WebkitBackgroundClip: "text",
          }}>Skilleareum</span> for <br/>
          Your “<span style={{
            backgroundClip: "text",
            color: "transparent",
            backgroundImage: "linear-gradient(to right, #0285FF, #1EEF32)",
            WebkitBackgroundClip: "text",
          }}>Incentivized Learning</span>” Journey</p>
        </div>

        <div className="w-full mt-16 grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 place-content-center content-center gap-10   ">

         {cards.map((card, index) => (
          <div key={index} className='w-[100%] mx-auto flex flex-col items-center justify-center '>
            <div className='w-16 h-16 bg-gradient-to-r from-[#0285FF] to-[#1EEF32]  rounded-full p-1.5 '>
              <div className='w-full h-full flex justify-center items-center bg-black rounded-full relative '>
                  <div className='w-14 h-14 flex justify-center items-center rounded-full overflow-hidden'>
                    <img src="https://skilleareumimages.s3.ap-south-1.amazonaws.com/New/Landing/AbstractDesign.svg" className=' w-14 h-14 mx-auto '/>
                  </div>
                  <img src={card.icon} className=' absolute top-3.5 w-6 h-6 animate-zoomMove  '/>
                </div>
            </div>

            <div className='mt-5'>
              <p className=' font-bold text-white text-center'>{card.title}</p>
              <p className='w-[90%] mx-auto text-sm text-[#8C8C8C] text-center mt-4'>{card.desc}</p>
            </div>

            <div className='mt-7'>
            <a href="/home" target="_blank">   <div className='flex justify-center items-center gap-7 border border-[#1F1F1F] rounded-full py-3 px-5 '>
                <p className=' font-semibold text-sm '>Get Started</p>
                <button className='w-12 h-8 bg-[#1A1A1A] rounded-full ml-2 '>
                  <FontAwesomeIcon icon={faArrowRight} className=' text-white ' />
                </button>
               </div></a>
            </div>
          </div>
       ))}

        </div>

      </div>
      </div>
    </div>
  )
}

export default Section2